import { PilaH, PilaV, Texto } from '@/components/atomos';
import IconoDinamico from '@/components/moleculas/IconoDinamico';
import { AlertaBannerHome } from '@/models/respuestas/usuario.model';
import { FC } from 'react';

const Alerta: FC<AlertaBannerHome> = ({ icono, subtitulo, tipo, titulo }) => {
  const colores: Record<AlertaBannerHome['tipo'], any> = {
    advertencia: {
      primario: 'orange.400',
      secundario: 'orange.100',
    },
    exito: {
      primario: 'bGreen.700',
      secundario: 'bGreen.100',
    },
    peligro: {
      primario: 'destructive.400',
      secundario: 'destructive.100',
    },
  };

  return (
    <PilaH
      py='1'
      px='2'
      rounded={'md'}
      outline={'1px solid'}
      outlineColor={colores[tipo].primario}
      color={colores[tipo].primario}
      bg={colores[tipo].secundario}
      spacing={2}
    >
      <IconoDinamico nombre={icono} size='40' />
      <PilaV alignItems='start' spacing={0}>
        <Texto fontWeight='medium' fontSize={'lg'} lineHeight='shorter'>
          {titulo}
        </Texto>
        <Texto>{subtitulo}</Texto>
      </PilaV>
    </PilaH>
  );
};

export default Alerta;
